// This icon file is generated automatically.
var PAlignCenterOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M3.13 2.6h7.75c.06 0 .12-.06.12-.13v-.88a.13.13 0 00-.13-.12H3.13a.13.13 0 00-.13.12v.88c0 .07.06.12.13.12zm7.75 6.62c.06 0 .12-.06.12-.13v-.87a.13.13 0 00-.13-.13H3.13a.13.13 0 00-.13.13v.87c0 .07.06.13.13.13h7.75zm2.24 2.19H.88a.13.13 0 00-.13.12v.88c0 .06.06.12.13.12h12.24c.07 0 .13-.05.13-.12v-.88a.13.13 0 00-.13-.12zm0-6.63H.88a.13.13 0 00-.13.13v.87c0 .07.06.13.13.13h12.24c.07 0 .13-.06.13-.13v-.87a.13.13 0 00-.13-.13z", "fill-rule": "nonzero" } }] }, "name": "p-align-center", "theme": "outlined" };
export default PAlignCenterOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PAlignCenterOutlined.js
// module id = 3203
// module chunks = 0